import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './TestimonialQuote.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
export var TestimonialQuote = function TestimonialQuote(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    background = _ref.background,
    color = _ref.color;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  if (!fields) {
    console.info('TestimonialQuote component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [TestimonialQuote component is empty: please provide data source]");
    }
    return null;
  }
  var hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  var hasQuoteMark = Boolean(get(fields, 'data.item.hasQuoteMark.jss.value'));
  var hasQuoteText = Boolean(get(fields, 'data.item.quoteText.jss.value'));
  var hasAuthorPicture = Boolean(get(fields, 'data.item.authorPicture.jss.value.src'));
  var hasAuthorName = Boolean(get(fields, 'data.item.authorName.jss.value'));
  var hasAuthorDescription = Boolean(get(fields, 'data.item.authorDescription.jss.value'));
  var hasColor = Boolean(get(params, 'Color') || get(fields, 'data.item.theme.targetItem.name'));
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var bgItem = background || get(params, 'BackgroundColorHex') || primaryColor;
  var colorItem = color || get(params, 'ColorHex') || getColorByTheme(primaryColor);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12 testimonial testimonial-quote ".concat(hasQuoteMark ? 'has-quote-mark' : 'no-quote-mark', " ").concat(!hasAuthorPicture && !hasAuthorName && !hasAuthorDescription && 'testimonial--no-author', "\n        "),
    "data-cy": "testimonial-quote",
    style: {
      background: bgItem
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 hide-on-z200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "testimonial__title col-md-2"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    className: "c-title__text",
    tag: "span",
    field: fields.data.item.title.jss,
    "data-cy": "testimonial-quote-title",
    style: {
      color: colorItem
    }
  }), ' '), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 show-on-z200"
  }), /*#__PURE__*/React.createElement("div", {
    className: "testimonial__content col-md-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial__quote"
  }, hasQuoteMark && /*#__PURE__*/React.createElement("span", {
    style: {
      color: colorItem
    },
    className: "c-content__text c-content__quote"
  }, "\""), hasQuoteText && /*#__PURE__*/React.createElement("span", {
    className: "c-content__text",
    "data-cy": "testimonial-quote-text"
  }, /*#__PURE__*/React.createElement(RichText, {
    tag: "span",
    style: {
      color: colorItem
    },
    field: fields.data.item.quoteText.jss
  }), hasQuoteMark && /*#__PURE__*/React.createElement("span", {
    style: {
      color: colorItem
    },
    className: "end-quote"
  }, "\u201C"))), (hasAuthorPicture || hasAuthorName || hasAuthorDescription) && /*#__PURE__*/React.createElement("div", {
    className: "testimonial__author"
  }, hasAuthorPicture && /*#__PURE__*/React.createElement("div", {
    className: "c-author__photo"
  }, /*#__PURE__*/React.createElement("img", {
    src: "".concat(fields.data.item.authorPicture.jss.value.src, "&cw=40&ch=40"),
    alt: fields.data.item.authorPicture.jss.value.alt,
    "data-cy": "testimonial-quote-author-picture"
  })), (hasAuthorName || hasAuthorDescription) && /*#__PURE__*/React.createElement("div", {
    className: "c-author__info"
  }, hasAuthorName && /*#__PURE__*/React.createElement("strong", {
    className: "c-author__name",
    style: {
      color: colorItem
    },
    "data-cy": "testimonial-quote-author-name"
  }, fields.data.item.authorName.jss.value), hasAuthorDescription && /*#__PURE__*/React.createElement(Text, {
    className: "c-author__info",
    tag: "span",
    style: {
      color: colorItem
    },
    field: fields.data.item.authorDescription.jss,
    "data-cy": "testimonial-quote-author-description"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  })))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className,
    anchorUrlParameter = _ref2.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
export var commonStyles = "c1kpmyaw";
export var ltrStyles = "l10y3w1o";
export var rtlStyles = "r1omgon9";
export default TestimonialQuote;